import { useOnce } from "./lifecycle";

/**
 * Hook used to change the current page background for as long as the component is rendered.
 * @param color The new backgroundColor to be used.
 */
export function usePageBackground(color: string) {
  useMetaThemeColor(color);

  useOnce(() => {
    const oldColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = color;

    return () => {
      document.body.style.backgroundColor = oldColor;
    };
  });
}

/**
 * Hook used to change the current page background image for as long as the component is rendered.
 * @param image The new background image path to be used.
 */
export function usePageBackgroundImage(image: string) {
  useOnce(() => {
    const oldImage = document.body.style.backgroundImage;
    document.body.style.backgroundImage = `url('${image}')`;

    return () => {
      document.body.style.backgroundImage = oldImage;
    };
  });
}

export function useMetaThemeColor(color: string) {
  useOnce(() => {
    // update "theme color" to match background for iOS safari.
    let meta;
    // check first if theme-color meta tag exists, so we don't ever have more than one.
    const existingMeta = document.querySelectorAll("meta[name=theme-color]");
    if (existingMeta.length) {
      meta = existingMeta[0];
    } else {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }

    const oldColor = meta.content;

    meta.content = color;
    return () => {
      meta.content = oldColor;
    };
  });
}
